import {
  Box,
  Button,
  Divider,
  TextInput,
  Typography,
  TextButton,
  Stack,
} from "@strapi/design-system";
import { message, Radio } from "antd";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { register, requestForgotPassword } from "../util/API";
import { useTranslation } from "react-i18next";
import { isValidEmail } from "../util/helper";

const ForgotPassword = ({ lng = "vi" }) => {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");

  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  useEffect(() => {
    if (lng) {
      i18n.changeLanguage(lng);
    }
  }, [lng]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const checkValid = isValid();
    if (!checkValid) {
      messageApi.open({
        type: "error",
        content: t("str_fill_in_all_info"),
      });
      return;
    }

    const checkEmailValid = isValidEmail(email);
    if (!checkEmailValid) {
      messageApi.open({
        type: "error",
        content: t("str_email_invalid"),
      });
      return;
    }

    try {
      const response = await requestForgotPassword({ email });
      if (response.status === 200) {
        messageApi.open({
          type: "success",
          content: t("str_forget_password_noti"),
        });

        return;
      }
    } catch (error) {}
  };

  //#region Validation
  const isValid = () => {
    if (email === "") return false;

    return true;
  };
  //#endregion

  const handleLoginLink = () => {
    if (lng === "en") navigate("/nomination/login");
    else navigate("/nomination/dang-nhap");
  };

  const handleSignUpLink = () => {
    if (lng === "en") navigate(`/nomination/sign-up`);
    else navigate(`/nomination/dang-ky`);
  };

  return (
    <div>
      {contextHolder}
      <Box padding={4}>
        <Typography variant="alpha" style={{ textAlign: "center" }}>
          {t("str_forget_password")}
        </Typography>
      </Box>
      <Divider />
      <Box padding={4}>
        <TextInput
          name="email"
          label={t("str_enter_recovery_email")}
          onChange={(e) => setEmail(e.target.value)}
        />
        <br />
        <Button color="primary" type="submit" onClick={handleSubmit}>
          <span style={{ textTransform: "uppercase" }}>
            {t("str_send_require")}
          </span>
        </Button>
      </Box>

      <Stack paddingLeft={4} spacing={4} horizontal>
        <TextButton onClick={handleSignUpLink}>{t("str_register")}</TextButton>
        <TextButton onClick={handleLoginLink}>{t("str_login")}</TextButton>
      </Stack>
    </div>
  );
};

export default ForgotPassword;
